var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "btn",
        class: _vm.getClass("mostrarReduzido"),
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            return _vm.toggleCampo("mostrarReduzido")
          },
        },
      },
      [
        _c("i", { staticClass: "fa fa-minus-square" }),
        _vm._v(" Mostrar reduzido\n  "),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn",
        class: _vm.getClass("mostrarApelido"),
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            return _vm.toggleCampo("mostrarApelido")
          },
        },
      },
      [_c("i", { staticClass: "fa fa-tags" }), _vm._v(" Mostrar apelido\n  ")]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn",
        class: _vm.getClass("formatacaoDC"),
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            return _vm.toggleCampo("formatacaoDC")
          },
        },
      },
      [
        _c("i", { staticClass: "fa fa-tags" }),
        _vm._v(" Formatar valores com: D/C\n  "),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn",
        class: _vm.getClass("formatacaoParenteses"),
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            return _vm.toggleCampo("formatacaoParenteses")
          },
        },
      },
      [
        _c("i", { staticClass: "fa fa-tags" }),
        _vm._v(" Formatar negativos com: ()\n  "),
      ]
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn",
        class: _vm.getClass("valoresEmMilhares"),
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            return _vm.toggleCampo("valoresEmMilhares")
          },
        },
      },
      [
        _c("i", { staticClass: "fa fa-tags" }),
        _vm._v(" Valores em milhares\n  "),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn",
        class: _vm.getClass("saldosZerados"),
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            return _vm.toggleCampo("saldosZerados")
          },
        },
      },
      [_c("i", { staticClass: "fa fa-tags" }), _vm._v(" Saldos zerados\n  ")]
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Nome do perfil")]),
          _vm._v(" "),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", id: "nomePerfil" },
            domProps: { value: _vm.nomePerfil },
            on: { input: _vm.changeCampo },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-actions" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.emitPersistirPerfil()
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isPerfilSistema()
                        ? "Salvar cópia de perfil pré-definido"
                        : "Salvar perfil"
                    ) +
                    "\n          "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.perfilSelecionado() && !_vm.isPerfilSistema()
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-danger",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.excluirPerfil()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Excluir perfil\n          "),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }